let nameMap = {
  创意组名称: "creativeGroupName",
  推广目标: "objective",
  应用名称: "appName",
  语言: "language",
  地区: "countryCode",
  创建时间: "createTime",
  优化目标: "optimizationGoal",
  出价: "dailyBudget",
  地区组名: "geoName",
  应用系统: "appOs",
  开始日期: "startDate",
  时分秒: "HHMMSS",
  首个图片名称: "firstImageName",
  首个视频名称: "firstVideoName",
};
let apiMap = {
  creativeGroupName: "创意组名称",
  objective: "推广目标",
  appName: "应用名称",
  language: "语言",
  countryCode: "地区",
  createTime: "创建时间",
  optimizationGoal: "优化目标",
  dailyBudget: "出价",
  geoName: "地区组名",
  appOs: "应用系统",
  startDate: "开始日期",
  HHMMSS: "时分秒",
  firstImageName: "首个图片名称",
  firstVideoName: "首个视频名称",
};

const showDataToApi = (str) => {
  let newStr = str.replace(/{(.*?)}/g, function (node, key) {
    return "{" + (nameMap[key] || key) + "}";
  });
  return newStr;
};

const apiDatatoShow = (str) => {
  let newStr = str.replace(/{(.*?)}/g, function (node, key) {
    return "{" + (apiMap[key] || key) + "}";
  });
  return newStr;
};

export default {
  showDataToApi,
  apiDatatoShow,
};
